import { MODALS } from '@/constants'
import { useModals } from '@/hooks'
import { Button } from '@chakra-ui/react'

export const ConnectWalletButton = ({ size }) => {
  const { openModal } = useModals()

  const handleConnectWallet = () => {
    openModal(MODALS.WALLET_OPTIONS)
  }

  return (
    <>
      <Button size={size} onClick={handleConnectWallet}>
        Connect Wallet
      </Button>
    </>
  )
}
